import { Injectable } from '@angular/core';
import { Cor } from '@tivic-team/manager-ts/dist/fta';
import { CorController } from 'app/controllers/fta/cor.controller';
import { LoaderService } from '../loader.service';


@Injectable()
export class CorService {

  constructor(
    private _corController: CorController,
    private _loaderService: LoaderService
  ) {}

  async getAll (isLoading:boolean=true):Promise<Cor[]>{
    try{
      if(isLoading) this._loaderService.show();
      return await this._corController.find().finally(() => {if (isLoading) this._loaderService.hide()});
    }catch(error){return [];}
  }  

  async get(cdCor:number):Promise<Cor>{
    this._loaderService.show();
    return this._corController.get(cdCor).finally(() => this._loaderService.hide());
  }
}
